export type ApiConfigType = {
    frontendBaseUrl: string
}

const config: ApiConfigType = {
    frontendBaseUrl: process.env.REACT_APP_FRONTEND_BASE_URL?.toString() || 'loopert.com'
}

export default config
